import { useState } from "react";
import styles from "./CollapsibleDepartmentDivisions.module.scss";
import { FormControlLabel, List, ListItemText, Radio, RadioGroup } from "@mui/material";
import { t } from "i18next";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";

interface Props {
  listName: string;
  divisions: string[] | undefined;
  departments: string[] | undefined;
  filterBy?: string | null;
  selectedDivisions: string[];
  selectedDepartments: string[];
  readonly: boolean;
  onFilterChanged: (filterBy?: string) => void;
  onChangeDivisionsSelected: (selected: string[]) => void;
  onChangeDepartmentsSelected: (selected: string[]) => void;
}

const CollapsibleDepartmentDivisions: React.FC<Props> = ({
  listName,
  divisions,
  departments,
  filterBy,
  selectedDivisions,
  selectedDepartments,
  readonly,
  onFilterChanged,
  onChangeDivisionsSelected,
  onChangeDepartmentsSelected
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filter, setFilterBy] = useState<string>(filterBy ?? 'byDivision');

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  const handleDivisionClick = (itemId: string) => {
    if (selectedDivisions.includes(itemId)) {
      onChangeDivisionsSelected(
        selectedDivisions.filter((selectedItem) => selectedItem !== itemId)
      );
    } else {
      onChangeDivisionsSelected([...selectedDivisions, itemId]);
    }
  };

  const handleDepartmentClick = (itemId: string) => {
    if (selectedDepartments.includes(itemId)) {
      onChangeDepartmentsSelected(
        selectedDepartments.filter((selectedItem) => selectedItem !== itemId)
      );
    } else {
      onChangeDepartmentsSelected([...selectedDepartments, itemId]);
    }
  };

  return (
    <div className={styles.collapsibleDepartmentDivisions}>
      <div onClick={toggleCollapsible} className={styles.header}>
        <p className={styles.listName}>{listName}</p>
        <div className={styles.icon}>{isOpen ? <ExpandLess /> : <ExpandMore  />}</div>
      </div>
      {isOpen && (
        <div>
        <RadioGroup
        aria-labelledby="filterBy-group-label"
        name="filterBy"
        className={styles.filterBy}
        row
        value={filter}
        onChange={(event) => {  
          if (filter !== event.currentTarget.value)
          {
              onFilterChanged(event.currentTarget.value);
          }

          setFilterBy(event.currentTarget.value);                    
        }}
      >
        <FormControlLabel value={'byDivision'} control={<Radio />} label={t("byDivision")} />
        <FormControlLabel value={'byDepartment'} control={<Radio />} label={t("byDepartment")} />
      </RadioGroup>
        {filter === 'byDivision' ? 
        (<List>
          {divisions?.map((item) => (
            <ListItemText key={`${listName}_${item}`}>
              <input
                disabled={readonly}
                type="checkbox"
                checked={selectedDivisions.includes(item)}
                onChange={() => handleDivisionClick(item)}
              />
              <span className={styles.listItem}>{item}</span>
            </ListItemText>
          ))}
        </List>) :(
        <List>
          {departments?.map((item) => (
            <ListItemText key={`${listName}_${item}`}>
              <input
                disabled={readonly}
                type="checkbox"
                checked={selectedDepartments.includes(item)}
                onChange={() => handleDepartmentClick(item)}
              />
              <span className={styles.listItem}>{item}</span>
            </ListItemText>
          ))}
        </List>)}
        </div>
      )}
    </div>
  );
};

export default CollapsibleDepartmentDivisions;
